<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="value != null"
>
    <v-card>
        <v-card-title>{{label}}</v-card-title>

        <v-card-text>

            <div
                style="display: flex; gap: 25px; width: 100%;"
            >
                <div
                    style="width: 50%"
                >
                    <m-edit-css-property-ctrl
                        :property_name="value.name"
                        :value="default_value"
                        :preview_text="preview_text"
                        is_default
                    />
                </div>
                <div
                     style="width: 50%"
                >
                    <m-edit-css-property-ctrl
                        :property_name="value.name"
                        :preview_text="preview_text"
                        v-model="value.value.raw_value"
                    />
                </div>
            </div>

            <div>
                <a
                    v-on:click="onClickFonts"
                    v-if="is_font_property"
                    style="color: #1976d2; text-decoration: underline; cursor: pointer;"
                >
                    <v-icon small left color="primary">mdi-font-awesome</v-icon>
                    Upload / Manage Your Organization's Fonts...
                </a>
            </div>

            <!-- Color Tools Section -->
            <div
                v-if="is_color_property"
                style="margin-top: 20px; padding-top: 15px; border-top: 1px solid rgba(0,0,0,0.1); "
            >
                <div class="subtitle-1 font-weight-medium mb-3">
                    <v-icon left color="primary">mdi-palette</v-icon>
                    Color Tools
                </div>
                <!-- Hex to RGBA Converter -->
                <div style="margin-bottom: 15px;">
                    <v-row no-gutters>
                        <v-col cols="8">
                            <v-text-field
                                v-model="hex_input"
                                label="Convert Hex Color Code (e.g., #FF5733)"
                                placeholder="#FF5733"
                                outlined
                                dense
                                @input="onHexInput"
                                :error-messages="hex_error_message"
                            />
                        </v-col>
                        <v-col cols="4" class="pl-2">
                            <v-btn
                                color="primary"
                                @click="convertHexToRgba"
                                :disabled="!is_valid_hex"
                                style="height: 40px; width: 100%;"
                            >
                                Convert
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <v-row>
                    <v-col cols="6">
                        <v-menu
                            bottom
                            offset-y
                        >

                        <template v-slot:activator="{ on }">

                            <v-btn
                                v-on="on"
                                block
                                outlined
                            >
                                <v-icon left>mdi-palette</v-icon>
                                Color Presets
                            </v-btn>

                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(item, index) in css_named_colors"
                                :key="'named_color_'+index"
                                v-on:click="onClickNamedColor(item)"
                            >
                                <v-list-item-title>{{item.text}}</v-list-item-title>
                            </v-list-item>

                        </v-list>

                        </v-menu>
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            v-on:click="onClickColorPicker"
                            block
                            outlined
                        >
                            <v-icon left>mdi-eyedropper</v-icon>
                            Color Picker
                        </v-btn>
                    </v-col>
                </v-row>
            </div>

        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                v-on:click="onClickReset"
                v-if="has_default_value"
            >
                Reset to Default Value
            </v-btn>

            <v-btn
                text
                v-on:click="onClickDelete"
                v-else
            >
                Delete...
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>


    </v-card>

    <!-- Color Picker Dialog -->
    <v-dialog
        v-model="color_picker_dialog"
        max-width="400"
        :attach="false"
        :z-index="9999"
    >
        <v-card>
            <v-card-title>Color Picker</v-card-title>
            <v-card-text>
                <v-color-picker
                    v-model="color_picker_value"
                    mode="rgba"
                    show-swatches
                    dot-size="25"
                    canvas-height="150"
                    swatches-max-height="200"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="color_picker_dialog = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="onColorPickerOk"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            label : null,
            value: null,
            property_name: null,
            preview_text: 'Lorem ipsum',
            color_picker_dialog: false,
            color_picker_value: { r: 255, g: 0, b: 0, a: 1 },
            hex_input: '',
            hex_error_message: '',
            css_named_colors: [
                {'text': 'Black', 'value': 'rgba(0,0,0,1.0)'},
                {'text': 'White', 'value': 'rgba(255,255,255,1.0)'},
                {'text': 'Blue', 'value': 'rgba(0, 0, 255,1)'},
                {'text': 'Cyan (Aqua)', 'value': 'rgba(0, 255, 255,1)'},
                {'text': 'Gray', 'value': 'rgba(128, 128, 128 ,1)'},
                {'text': 'Green', 'value': 'rgba(0, 128, 0 ,1)'},
                {'text': 'Lime', 'value': 'rgba(0, 255, 0 ,1)'},
                {'text': 'Magenta (Fuchsia)', 'value': 'rgba(255, 0, 255 ,1)'},
                {'text': 'Maroon', 'value': 'rgba(128, 0, 0 ,1)'},
                {'text': 'Navy', 'value': 'rgba(0, 0, 128 ,1)'},
                {'text': 'Olive', 'value': 'rgba(128, 128, 0 ,1)'},
                {'text': 'Purple', 'value': 'rgba(128, 0, 128 ,1)'},
                {'text': 'Red', 'value': 'rgba(255, 0, 0 ,1)'},
                {'text': 'Silver', 'value': 'rgba(192, 192, 192 ,1)'},
                {'text': 'Teal', 'value': 'rgba(0, 128, 128 ,1)'},
                {'text': 'Yellow', 'value': 'rgba(255, 255, 0 ,1)'},
            ],
        }
    },

    methods: {
        showDialog(params)
        {
            this.value = _.cloneDeep(params.value);
            this.label = _.cloneDeep(params.label);
            this.preview_text = params.preview_text || 'Lorem ipsum';

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('modify', {
                'op': 'set-property',
                'property_name': this.value.name,
                'value': this.value.value.raw_value
            });
        },

        onCancel()
        {
            this.dialog = false;
        },
        
        onClickReset()
        {
            this.value.value = _.cloneDeep(this.value.default_value);
        },

        onClickDelete()
        {
            this.$rc.confirm({
                'title': 'Delete this property',
                'body': 'Delete the '+this.value.name+' property?<br/><br/>This can not be undone.',
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doDelete();
                },
            });
        },

        doDelete()
        {
            this.dialog = false;
            this.$emit('modify', {
                'op': 'delete',
                'property_name': this.value.name,
            });
        },

        onClickFonts()
        {
            // Open in new tab to preserve user's lightbox editing context
            const route_url = this.$router.resolve({
                'name': 'settings-organization-fonts',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
            window.open(route_url.href, '_blank');
        },

        onClickNamedColor(item)
        {
            this.value.value.raw_value = item.value;
        },

        onClickColorPicker()
        {
            // Initialize color picker with current color
            // Parse the current RGBA value if it exists
            const current_value = this.value.value.raw_value;
            if (current_value && current_value.includes('rgba')) {
                const rgba_match = current_value.match(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
                if (rgba_match) {
                    this.color_picker_value = {
                        r: parseInt(rgba_match[1]),
                        g: parseInt(rgba_match[2]),
                        b: parseInt(rgba_match[3]),
                        a: parseFloat(rgba_match[4])
                    };
                }
            }

            this.color_picker_dialog = true;
        },

        onColorPickerOk()
        {
            const rgba = this.color_picker_value;

            // Sanitize RGB values to prevent invalid values like 256
            const sanitized_r = Math.max(0, Math.min(255, Math.round(rgba.r || 0)));
            const sanitized_g = Math.max(0, Math.min(255, Math.round(rgba.g || 0)));
            const sanitized_b = Math.max(0, Math.min(255, Math.round(rgba.b || 0)));
            const sanitized_a = Math.max(0, Math.min(1, rgba.a || 1));

            const color_value = `rgba(${sanitized_r}, ${sanitized_g}, ${sanitized_b}, ${sanitized_a})`;
            this.value.value.raw_value = color_value;
            this.color_picker_dialog = false;
        },

        onHexInput()
        {
            this.hex_error_message = '';
            // Clear error message when user types
        },

        convertHexToRgba()
        {
            if (!this.is_valid_hex) {
                return;
            }

            const hex = this.hex_input.replace('#', '');
            let r = parseInt(hex.substring(0, 2), 16);
            let g = parseInt(hex.substring(2, 4), 16);
            let b = parseInt(hex.substring(4, 6), 16);

            // Sanitize RGB values to ensure they're valid (should always be 0-255 from hex, but safety check)
            r = Math.max(0, Math.min(255, r || 0));
            g = Math.max(0, Math.min(255, g || 0));
            b = Math.max(0, Math.min(255, b || 0));

            // Default alpha to 1.0 for full opacity
            const rgba_value = `rgba(${r}, ${g}, ${b}, 1.0)`;
            this.value.value.raw_value = rgba_value;

            // Clear the hex input after successful conversion
            this.hex_input = '';
        },

        hexToRgba(hex)
        {
            // Remove # if present
            hex = hex.replace('#', '');

            // Validate hex format
            if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
                return null;
            }

            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            return { r, g, b, a: 1.0 };
        },
    },

    computed: {
        default_value() 
        {
            if ( this.value == null || this.value.default_value == null )
                return null;

            return this.value.default_value.raw_value;
        },

        has_default_value()
        {
            return this.value != null && this.value.default_value != null && this.value.default_value.raw_value != null;
        },

        is_color_property()
        {
            return this.label && (
                this.label.toLowerCase().includes('color') ||
                this.label.toLowerCase().includes('background') ||
                this.label.toLowerCase().includes('scrollbar-')
            );
        },

        is_font_property()
        {
            return this.label && (
                this.label.toLowerCase().includes('font-family') ||
                this.label.toLowerCase().includes('font')            );
        },

        is_valid_hex()
        {
            if (!this.hex_input) {
                return false;
            }

            const hex = this.hex_input.replace('#', '');
            return /^[0-9A-Fa-f]{6}$/.test(hex);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>